import { Radio } from '@cmg/common';
import styled from 'styled-components';

export const StyledRadioCheck = styled(Radio)`
  width: 45px;
  padding: 0px;
`;
